import React, { Component } from "react";
import { connect } from "react-redux";
import * as dupixentActions from "../../store/actions/Index";
import * as authActions from "../../store/actions/auth";
import * as ActionTypes from "../../store/actions/ActionTypes";
import AppBar from "../../components/AppBar/AppBar";
import Container from "@material-ui/core/Container";
import SideMenu from "../../components/SideMenu/SideMenu";
import Users from "../Users/Users";
import Questions from "../Questions/Questions";
import TopQuestions from "../TopQuestions/TopQuestions";
import Analytics from "../Analytics/Analytics";

class Manager extends Component {
	state = {
		fieldValues: {
			image: ""
		},
		loading: false,
		decisionModalOpen: false,
		modifyFormModalOpen: false,
		modifyTextFormOpen: false,
		idToDelete: 0,
		idToUpdate: 0,
		deleting: false,
		
		analytics_data: {"country":0, 
		"category":0, 
		"period":1},
	};

	componentDidMount() {


		this.props.onLoadUsers(this.props.token);
		this.props.loadQuestions();
		this.props.loadTopQuestions();
		this.props.onLoadAnalytics(this.state.analytics_data);
		{/*this.props.onLoadAnalyticsHours(this.state.analytics_data);
		this.props.onLoadAnalyticsAct(this.state.analytics_data);
		this.props.onLoadAnalyticsHeat(this.state.analytics_data);*/}

	}

	handleSideMenu = () => {
		this.setState({ sideMenuOpen: !this.state.sideMenuOpen });
	};

	render() {
		const containerStyle = {
			marginTop: "50px"
		};

		let questions = this.props.questionsMenuOpen ? (
			<Questions
				questions={this.props.questions}
				loadQuestions={this.props.loadQuestions}
				loadLevels={this.props.loadLevels}
				levels = {this.props.levels}
				levelCategories ={this.props.levelCategories}
				loadLevelCategories={this.props.loadLevelCategories}
				handleSaveQuestion={this.props.saveQuestion}
				handleUpdateQuestion={this.props.updateQuestion}
				handleSaveQuestionConnect={this.props.saveQuestionConnect}
				handleUpdateQuestionConnect={this.props.updateQuestionConnect}
				deleteQuestion={this.props.deleteQuestion}
				idquestion={this.props.idquestion}
				country={this.props.country}
				token={this.props.token}
			/>
		) : null;

		let topquestions = this.props.topquestionsMenuOpen ? (
			<TopQuestions
				topquestions={this.props.topquestions}
				token={this.props.token}
			/>
		) : null;
		let users = this.props.usuariosMenuOpen ? (
			<Users
				users={this.props.usersList}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadUsersGeneral={this.props.onLoadUsers}
				loadUsersMonth={this.props.onLoadUsersMonth}
				loadUsersWeek={this.props.onLoadUsersWeek}
				createUser={this.props.createUser}
				deleteUser={this.props.deleteUser}
				country={this.props.country}
			/>
		) : null;

		let analytics = this.props.analyticsMenuOpen ? (
			<Analytics
				analytics={this.props.ana_efficiency}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadAnalytics={this.props.onLoadAnalytics}
				country={this.props.country}
			/>
		):null;

		{/*let analytics_hours = this.props.anaHoursMenuOpen ? (
			<Analytics
				analytics={this.props.ana_hours}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadAnalytics={this.props.onLoadAnalyticsHours}
				country={this.props.country}
			/>
		):null;

		let analytics_act = this.props.anaActMenuOpen ? (
			<Analytics
				analytics={this.props.ana_act}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadAnalytics={this.props.onLoadAnalyticsAct}
				country={this.props.country}
			/>
		):null;

		et analytics_heat = this.props.analyticsMenuOpen ? (
			<Analytics
				analytics={this.props.ana_heat}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadAnalytics={this.props.onLoadAnalyticsHeat}
				country={this.props.country}
			/>
		):null;*/}

		return (
			<div>
				<AppBar
					openMenu={this.props.handleOpenSideMenu}
					onClickLogout={this.props.handleLogout}
				/>
				<SideMenu
					open={this.props.sideMenuOpen}
					handleOpenUsuarios={this.props.handleOpenUsuarios}
					handleOpenQuestions={this.props.handleOpenQuestions}
					handleOpenTopQuestions={this.props.handleOpenTopQuestions}
					handleOpenAnalytics={this.props.handleOpenAnalytics}
					handleOpenAnalyticsHours={this.props.handleOpenAnalyticsHours}
					handleOpenAnalyticsAct={this.props.handleOpenAnalyticsAct}
					handleOpenAnalyticsHeat={this.props.handleOpenAnalyticsHeat}
				/>
				<Container fixed style={containerStyle}>
					{users}
					{questions}
					{topquestions}
					{analytics}
					{/*{analytics_hours}
					{analytics_act}
					{analytics_heat}*/}
				</Container>
			</div>
		);
	}
}

const mapStateToProps = state => {

	return {
		questions: state.reducer.questions,
		topquestions: state.reducer.topquestions,

		levels: state.reducer.levels,
		levelCategories: state.reducer.levelCategories,
		sideMenuOpen: state.reducer.sideMenuOpen,
		usuariosMenuOpen: state.reducer.usuariosMenuOpen,
		questionsMenuOpen: state.reducer.questionsMenuOpen,
		topquestionsMenuOpen: state.reducer.topquestionsMenuOpen,
		analyticsMenuOpen: state.reducer.analyticsMenuOpen,
		token: state.authReducer.token,
		usersList: state.reducer.users,
		ana_efficiency: state.reducer.analytics/*,
		ana_hours: state.reducer.analytics_hours,
		ana_act: state.reducer.analytics_act,
		ana_heat: state.reducer.analytics_heat*/
	};
};

const mapDispatchToProps = dispatch => {
	return {
		loadQuestions: () => dispatch(dupixentActions.loadQuestions()),
		loadTopQuestions: () => dispatch(dupixentActions.loadTopQuestions()),

		loadLevels: (idcategory) => dispatch(dupixentActions.loadLevels(idcategory)),
		loadLevelCategories: (idlevel) => dispatch(dupixentActions.loadLevelCategories(idlevel)),
		saveQuestion: (question) => dispatch(dupixentActions.saveQuestion(question)),
		updateQuestion: (question) => dispatch(dupixentActions.updateQuestion(question)),
		updateQuestionConnect: (question) => dispatch(dupixentActions.updateQuestionConnect(question)),
		deleteQuestion: (idquestion) => dispatch(dupixentActions.deleteQuestion(idquestion)),

		saveQuestionConnect: (question) => dispatch(dupixentActions.saveQuestionConnect(question)),

		onLoadAnalytics: (anarequest) => dispatch(dupixentActions.loadAnalytics(anarequest)),
		/*onLoadAnalyticsHours: (anhoursrequest) => dispatch(dupixentActions.loadAnalyticsHours(anhoursrequest)),
		onLoadAnalyticsAct: (anactrequest) => dispatch(dupixentActions.loadAnalyticsAct(anactrequest)),
		onLoadAnalyticsHeat: (anheatrequest) => dispatch(dupixentActions.loadAnalyticsHeat(anheatrequest)),*/

		onLoadUsers: token => dispatch(dupixentActions.loadUsers(token)),
		onLoadUsersMonth: token => dispatch(dupixentActions.loadUsersMonth(token)),
		onLoadUsersWeek: token => dispatch(dupixentActions.loadUsersWeek(token)),
		handleOpenSideMenu: () =>
			dispatch({ type: ActionTypes.OPENCLOSE_SIDEMENU }),
		handleOpenUsuarios: () => dispatch({ type: ActionTypes.OPEN_USUARIOS }),		
		handleOpenQuestions: () => dispatch({ type: ActionTypes.OPEN_QUESTIONS }),
		handleOpenTopQuestions: () => dispatch({ type: ActionTypes.OPEN_TOPQUESTIONS }),
		handleOpenAnalytics: () => dispatch({type: ActionTypes.OPEN_ANALYTICS }),
		handleLogout: () => dispatch(authActions.authLogOut()),
		createUser: (token, user) => dispatch(dupixentActions.createUser(token, user)),
		deleteUser: (token, user) => dispatch(dupixentActions.deleteUser(token, user))

	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
